// src/Ducks/books.js
import {asyncInitialState, asyncOnError, asyncOnRequest, asyncOnSuccess, asyncSelectors, createActions} from './utils';

export const {types, actions} = createActions(
    {
        asyncs: {
            getBooks: (data) => data,
            getBookDetails: (data) => data,
            createBook: (data) => data,
            updateBook: (data) => data,
            bulkImportBooks: (data) => data,
            archiveBook: (data) => data,
            restoreBook: (data) => data,
        },
    },
    'books'
);

let initialState = asyncInitialState({
    books: null,
    bookDetails: null,
    createdBook: null,
    updatedBook: null,
    bulkImportResult: null,
    archivedBook: null,
    restoredBook: null,
    errorMessage: '',
    success: false,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.getBooks:
        case types.getBookDetails:
        case types.createBook:
        case types.updateBook:
        case types.bulkImportBooks:
        case types.archiveBook:
        case types.restoreBook:
            return asyncOnRequest(state, action);

        case types.saga.getBooks.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                books: action.payload.data,
                errorMessage: '',
            }));

        case types.saga.getBookDetails.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                bookDetails: action.payload.data,
                errorMessage: '',
            }));

        case types.saga.createBook.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                createdBook: action.payload.data,
                success: true,
                errorMessage: '',
            }));

        case types.saga.updateBook.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                updatedBook: action.payload.data,
                success: true,
                errorMessage: '',
            }));

        case types.saga.bulkImportBooks.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                bulkImportResult: action.payload.data,
                success: true,
                errorMessage: '',
            }));

        case types.saga.archiveBook.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                archivedBook: action.payload.data,
                success: true,
                errorMessage: '',
            }));

        case types.saga.restoreBook.success:
            return asyncOnSuccess(state, action, (data, action) => ({
                ...data,
                restoredBook: action.payload.data,
                success: true,
                errorMessage: '',
            }));

        case types.saga.getBooks.failure:
        case types.saga.getBookDetails.failure:
        case types.saga.createBook.failure:
        case types.saga.updateBook.failure:
        case types.saga.bulkImportBooks.failure:
        case types.saga.archiveBook.failure:
        case types.saga.restoreBook.failure:
            return asyncOnError(state, action);

        default:
            return state;
    }
};

const asyncSelector = asyncSelectors(
    (state) => state.books,
    {errorMessage: (data) => data.errorMessage}
);

const syncSelector = {
    isLoading: (state) => state.books.loading,
    books: (state) => state.books.data.books,
    bookDetails: (state) => state.books.data.bookDetails,
    bulkImportResult: (state) => state.books.data.bulkImportResult,
};

export const selectors = Object.assign({}, asyncSelector, syncSelector);
